import { render } from "./datiLead.vue?vue&type=template&id=6373c08f&ts=true"
import script from "./datiLead.vue?vue&type=script&lang=ts"
export * from "./datiLead.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__